import { Formik } from "formik";
import * as yup from "yup";
import React, { Component } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import {
  RenderSelectInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";
import { NotificationManager } from "react-notifications";
import { addMarkUp } from "app/services/markUpService";
import { useState } from "react";
import { useEffect } from "react";
import { addAirport, addUpdateAirlines } from "app/services/SearchService";

const airlinesSchema = yup.object().shape({
  flightCarrierName: yup.string().required("Airlines Name is required"),
  flightcarrierCode: yup.string().required("Airlines Code is required"),
  flightType: yup.string().required("Operation Mode is required"),
  // flightCarrierDesc: yup.string().required("City Code is required"),
});

function AddAirlines({
  handleClose,
  handleShow,
  editId,
  show,
  editRow,
  loadAirlines,
}) {
  const [isShow, setIsShow] = useState(false);
  const airlines = {
    id: 0,
    flightCarrierName: "",
    flightcarrierCode: "",
    flightType: "",
    flightCarrierStatus: true,
    flightCarrierLogo: "",
    flightCarrierDesc: "",
  };
  const [state, setState] = useState(airlines);

  const airlinesTypeOptions = [
    { value: "both", label: "Both" },
    { value: "domestic", label: "Domestic" },
    { value: "International", label: "International" },
  ];

  const handleSubmit = async (values) => {
    debugger;
    setIsShow(true);
    const response = await addUpdateAirlines(values);
    console.log(response);
    try {
      if (response.status == "Success") {
        {
          values?.id > 0
            ? NotificationManager.success(
                "Airport Information Update successfully"
              )
            : NotificationManager.success(
                "Airport Information Add successfully"
              );
        }
        loadAirlines();
        handleClose();
        setIsShow(false);
      } else {
        setIsShow(false);
        loadAirlines();
        NotificationManager.success("Something went wrong");
        handleClose();
      }
    } catch (error) {
      setIsShow(false);
      loadAirlines();
      NotificationManager.error("something went to be wrong");
      handleClose();
      console.log(error);
      throw error;
    }
  };

  useEffect(() => {
    if (editRow) {
      setState(editRow);
    } else {
      setState(airlines);
    }
  }, [editRow]);

  return (
    <div>
      <Formik
        initialValues={state}
        validationSchema={airlinesSchema}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          isSubmitting,
        }) => (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {values?.id > 0 ? "Update Airlines" : "Add Airlines"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleSubmit} className="p-3">
                <Form.Group>
                  <RenderSelectInput
                    type="text"
                    display="Operation Mode"
                    name="flightType"
                    value={values?.flightType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.flightType}
                    touched={touched?.flightType}
                    items={airlinesTypeOptions}
                    required
                  ></RenderSelectInput>
                </Form.Group>
                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Airlines Code"
                    placeholder="Enter Airlines Code"
                    name="flightcarrierCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.flightcarrierCode}
                    value={values?.flightcarrierCode}
                    touched={touched.flightcarrierCode}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Airlines Name"
                    placeholder="Enter Airlines Name"
                    name="flightCarrierName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.flightCarrierName}
                    error={errors.flightCarrierName}
                    autoComplete="off"
                    touched={touched.flightCarrierName}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <RenderTextArea
                    type="text"
                    name="flightCarrierDesc"
                    display="Airlines Description"
                    placeholder="Airlines Description"
                    value={values.flightCarrierDesc}
                    error={errors.flightCarrierDesc}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    touched={touched.flightCarrierDesc}
                    // required
                  ></RenderTextArea>
                </Form.Group>

                <Row>
                  <div className="m-auto text-center">
                    {isShow ? (
                      <Button variant="primary" size="md" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "10px" }}
                        />
                        {values?.id > 0 ? "Updating..." : "Adding..."}
                      </Button>
                    ) : (
                      <Button variant="primary" size="md" type="submit">
                        {values?.id > 0 ? "Update Airlines" : "Add Airlines"}
                      </Button>
                    )}
                  </div>
                </Row>
              </form>
            </Modal.Body>
          </Modal>
        )}
      </Formik>
    </div>
  );
}

export default AddAirlines;
